import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Popover, FormGroup, Divider, makeStyles, InputLabel } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';

import { ChipFilterWrapper, AutocompleteWrapper } from 'src/components';


const useStyles = makeStyles(theme => ({
  popoverTextField: {
    minWidth: 160,
  },
  chip: {
    backgroundColor: 'transparent',
    height: '30px',
  },
  group: {
    padding: '3px',
    borderRadius: theme.shape.borderRadius,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.common.gray400,
  },
}));

const getMonthName = monthNumber => {
  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
  ];
  return months[monthNumber - 1];
};

const FilterYearMonthComparison = ({ prevValue, onChange, options, inline = false }) => {

  const classes = useStyles();

  const [ anchorEl, setAnchorEl ] = useState(null);
  const isOpenPopover = Boolean(anchorEl);
  const popoverId = isOpenPopover ? 'simple-popover' : undefined;

  const openPopup = event => setAnchorEl(event.currentTarget);

  const closePopup = () => setAnchorEl(null);

  const [ yearMonth, setYearMonth ] = useState(prevValue[0]);
  const [ comparisonYearMonth, setComparisonYearMonth ] = useState(prevValue[1]);

  useEffect(() => {
    setYearMonth(prevValue[0]);
    setComparisonYearMonth(prevValue[1]);
  }, [ prevValue ]);

  const handleConfirm = () => {
    // TODO: implementar modo inline (cuando sea necesario)
    if (inline) {
      throw new Error('Inline mode is not implemented for FilterYearMonthComparison');
    } else {
      onChange([ yearMonth, comparisonYearMonth ]);
      closePopup();
    }
  };

  const getMonthLabel = monthNumber => getMonthName(monthNumber);

  const commonAutocompleteProps = {
    fullWidth: true,
    getOptionSelected: (option, [ value ]) => option === value,
    size: 'very-small',
  };

  return (
    <>
      {inline ?
        <>
          Falta implementar modo sin popover
        </>
        :
        <>
          <Popover
            id={popoverId}
            open={isOpenPopover}
            anchorEl={anchorEl}
            onClose={closePopup}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <Box px={2} pt={2} pb={1}>
              <FormGroup>
                <InputLabel shrink>Mes y año</InputLabel>
                <Box className={classes.group} width={270} display="flex" alignItems="center">
                  <AutocompleteWrapper
                    {...commonAutocompleteProps}
                    options={options.months}
                    getOptionLabel={getMonthLabel}
                    onChange={(_, newValue) => setYearMonth(prev => ({ ...prev, month: newValue }))}
                    value={[ yearMonth.month ]}
                  />
                  <Box mx={0.5} />
                  <AutocompleteWrapper
                    {...commonAutocompleteProps}
                    options={options.years}
                    getOptionLabel={option => option.toString()}
                    onChange={(_, newValue) => setYearMonth(prev => ({ ...prev, year: newValue }))}
                    value={[ yearMonth.year ]}
                  />
                </Box>
                <br />
                <InputLabel shrink>Mes y año a comparar</InputLabel>
                <Box className={classes.group} width={270} display="flex" alignItems="center">
                  <AutocompleteWrapper
                    {...commonAutocompleteProps}
                    options={options.months}
                    getOptionLabel={getMonthLabel}
                    onChange={(_, newValue) => setComparisonYearMonth(prev => ({ ...prev, month: newValue }))}
                    value={[ comparisonYearMonth.month ]}
                  />
                  <Box mx={0.5} />
                  <AutocompleteWrapper
                    {...commonAutocompleteProps}
                    options={options.years}
                    getOptionLabel={option => option.toString()}
                    onChange={(_, newValue) => setComparisonYearMonth(prev => ({ ...prev, year: newValue }))}
                    value={[ comparisonYearMonth.year ]}
                  />
                </Box>

                <Box mt={4}>
                  <Divider />
                </Box>
                <Box mt={1} display="flex" alignSelf="flex-end">
                  <Button color="default" size="small" onClick={handleConfirm}>Aplicar</Button>
                </Box>
              </FormGroup>
            </Box>
          </Popover>
          <ChipFilterWrapper
            isActive={true}
            isFocused={isOpenPopover}
            icon={<ArrowDropDown fontSize="small" />}
            label={`${getMonthName(prevValue[0].month)} ${prevValue[0].year} vs ${getMonthName(prevValue[1].month)} ${prevValue[1].year}`}
            onClick={openPopup}
            className={classes.chip}
          />
        </>
      }
    </>
  );
};

FilterYearMonthComparison.propTypes = {
  prevValue: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  inline: PropTypes.bool,
  options: PropTypes.object.isRequired,
};


export {
  FilterYearMonthComparison,
};